const app = (state = {}, action) => {
    switch (action.type) {
        case 'SET_AUTH':
            return { ...state, auth: action.auth }
        case 'SET_USER':
            return { ...state, user: action.user }

        case 'SET_READY':
            return { ...state, ready: action.ready }
        case 'SET_CURRENCY':
            return { ...state, currency: action.currency }
        case 'SET_SIMPLE_POPUP':
            return { ...state, simplePopup: action.simplePopup }
        case 'SET_ROUTES':
            return { ...state, routes: action.routes }
        case 'SET_MENUS':
            return { ...state, menus: action.menus }
        case 'SET_SOCIALS':
            return { ...state, socials: action.socials }
        case 'SET_CONTACTS':
            return { ...state, contacts: action.contacts }
        case 'SET_ACTIVE_MOBILE_MENU':
            return { ...state, mobile_menu: action.active }
        case 'SET_MOBILE':
            return { ...state, mobile: action.status }
        case 'SET_HOME_CONTENT':
            return { ...state, homeContent: action.homeContent }
        case 'SET_CONTENT':
            return {
                ...state,
                content: { ...state.content, [action.date.page]: action.date.content }
            }
        case 'SET_BACK_TO_MRKT':
            return { ...state, backToMrkt: action.backToMrkt }
        case 'SET_FILTER':
            return { ...state, filters: action.filters }
        case 'SET_MRKT_PAGINATE':
            return { ...state, mrktPaginate: action.mrktPaginate }
        case 'SET_CART':
            return {
                ...state,
                cart: [...(action.cart || [])]
            }
        case 'SET_CHECKOUT_TAB':
            return {
                ...state,
                checkout_tab: action.tab
            }
        case 'SET_CHECKOUT_CART':
            return {
                ...state,
                checkout_cart: { ...(action.cart || {}) }
            }
        case 'SET_CHECKOUT_ORDER':
            return {
                ...state,
                checkout_order: { ...(action.cart || {}) }
            }
        case 'ADD_CART':
            if (action.item.hasOwnProperty('id')) {
                return {
                    ...state,
                    cart: [...state.cart, action.item]
                }
            } else {
                return {
                    ...state
                }
            }
        case 'SET_HEADER_CONTENT':
            return { ...state, headerContent: action.headerContent }
        case 'SET_PLANS':
            return { ...state, plans: action.plans }
        case 'CHOOSE_PLAN':
            return { ...state, plan: action.plan }
        case 'SET_PLANS_DETAILS':
            return { ...state, plansDetails: action.plansDetails }
        case 'SET_LANG':
            return { ...state, lang: action.lang }
        default:
            return { ...state }
    }
}

export default app
